<template>
  <section
    class="cookie-policy"
    :class="{ animation: isAccepting }"
    v-if="show && !isAccepted"
  >
    <transition name="toggleContent" mode="out-in">
      <div class="container" v-if="!costumActive" key="1">
        <p
          class="font-13 pangram-medium main-text"
          v-html="cookies.cookies"
        ></p>
        <div class="cookie-buttons">
          <div
            class="accept font-13 pangram-medium buttons pointer"
            @click="acceptCookies()"
          >
            {{ $fn.tr("დიახ, ვეთანხმები") }}
          </div>
          <div
            class="cancel font-13 pangram-medium buttons pointer"
            @click="acceptCookies()"
          >
            <!-- {{ $fn.tr("მსურს გავიგო მეტი") }} -->
            {{ $fn.tr("არ ვეთანხმები") }}
          </div>
        </div>
      </div>
      <div key="2" class="costumize-cookies" v-else>
        <div class="container">
          <div @click="costumize()">
            costumize
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
// import IconComponent from "@/components/IconComponent";

export default {
  components: {
    // IconComponent
  },
  data() {
    return {
      show: true,
      item1: false,
      item2: false,
      item3: false,
      isAccepted: false,
      isAccepting: false,
      costumActive: false
    };
  },
  watch: {
    localStorageStatus: {
      immediate: true,
      handler(val) {
        this.isAccepted = val;
      }
    }
  },
  computed: {
    // getINDX() {
    //   return _.get(this.$store.state.main.indx, "widgets.cookie");
    // },
    localStorageStatus() {
      return typeof localStorage.getItem("acceptCookies") === "string" &&
        localStorage.getItem("acceptCookies") !== "undefined"
        ? JSON.parse(localStorage.getItem("acceptCookies"))
        : false;
    },
    cookies() {
      const data = this.$store.state.main.indx?.widgets?.cookies;
      return data;
    }
  },
  methods: {
    closeCookie() {
      this.show = !this.show;
    },
    costumize() {
      this.costumActive = !this.costumActive;
    },
    acceptCookies() {
      localStorage.setItem("acceptCookies", true);
      this.isAccepting = true;
      setTimeout(() => {
        this.isAccepted = true;
      }, 400);
    }
  }
};
</script>

<style lang="scss">
.cookie-policy {
  bottom: 0;
  width: 100%;
  padding: 30px 0;
  position: fixed;
  z-index: 99999999999;
  transition: 0.4s ease-in-out;
  background: rgba(26, 26, 26, 0.9);
  &.animation {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: 0.4s ease-in-out;
  }
  .main-text {
    color: $white;
    line-height: 24px;
    text-align: center;
    margin-bottom: 30px;
    a {
      color: $blue;
      transition: 0.4s ease-in-out;
      &:hover {
        color: $red;
        transition: 0.4s ease-in-out;
      }
    }
  }
  .cookie-buttons {
    width: 100%;
    display: flex;
    justify-content: center;
    @media (max-width: 767px) {
      flex-direction: column;
      align-items: center;
    }
    .buttons {
      height: 40px;
      display: flex;
      padding: 0 30px;
      min-width: 218px;
      background: $white;
      align-items: center;
      justify-content: center;
      @media (max-width: 767px) {
        width: 100%;
      }
      &:first-child {
        margin-right: 30px;
        @media (max-width: 767px) {
          margin-right: 0;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
